<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">New My Activity</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /
      <router-link to="/marketing">
        Marketing
      </router-link>
      /
      <router-link to="/marketing/my-activity">
        My Activity
      </router-link>
      /
      <b>New</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <form class="container-fluid needs-validation" novalidate @submit.prevent="submitForm">
          <div class="mb-3">
            <!-- Radio Buttons -->
            <label for="type" class="form-label">Type</label>
            <div class="d-flex flex-wrap">
              <div class="form-check form-check-inline mb-2 me-4 custom-radio">
                <input v-model="data.type" :value="2" type="radio" id="rsvp" name="type" class="form-check-input "
                  required @change="handleType" />
                <label for="rsvp" class="form-check-label">RSVP</label>
              </div>
              <div class="form-check form-check-inline mb-2 me-4">
                <input v-model="data.type" :value="3" type="radio" id="request-tba" name="type" class="form-check-input"
                  required @change="handleType" />
                <label for="request-tba" class="form-check-label">Request for Call (TBA)</label>
              </div>
              <div class="form-check form-check-inline mb-2">
                <input v-model="data.type" :value="4" type="radio" id="request-tbk" name="type" class="form-check-input"
                  required @change="handleType" />
                <label for="request-tbk" class="form-check-label">Request for Call (TBK)</label>
              </div>
            </div>
            <div v-if="errors.type">
              <small class="text-danger">{{ errors.type }}</small>
            </div>
          </div>

          <!-- Title -->
          <div class="mb-3">
            <label for="title" class="form-label">Title</label>
            <input v-model="data.title" type="text" id="title" class="form-control" placeholder="My Activity Title..."
              required />
            <div v-if="errors.title">
              <small class="text-danger">{{ errors.title }}</small>
            </div>
          </div>

          <!-- Short Description -->
          <div class="mb-3">
            <label for="short-description" class="form-label">Short Description</label>
            <input v-model="data.short_description" type="text" id="short-description" class="form-control"
              placeholder="Enter short description" required />
            <div v-if="errors.short_description">
              <small class="text-danger">{{ errors.short_description }}</small>
            </div>
          </div>

          <!-- Long Description -->
          <div class="mb-3">
            <label for="long-description" class="form-label">Long Description</label>
            <textarea v-model="data.long_description" id="long-description" class="form-control"
              placeholder="Enter long description" rows="4" required></textarea>
            <div v-if="errors.long_description">
              <small class="text-danger">{{ errors.long_description }}</small>
            </div>
          </div>
          <div class="d-flex flex-column mb-3 " v-if="data.type === 3 || data.type === 4">
            <label for="product_id" class="block">Product</label>
            <select id="product_id" v-model="data.product_id" class="border p-2 rounded w-full mt-1 bg-gray-100"
              :disabled="isDisabled" @change="onChangeProduct">
              <option v-for="product in data.type === 3 ? tba_products : tbk_products" :key="product.id"
                :value="product.id">{{ product.name }}</option>
            </select>

            <div v-if="errors.field1">
              <small class="text-danger">{{ errors.product }}</small>
            </div>
          </div>
          <div v-if="data.type === 2" class="mb-3">
            <div class="row g-2">
              <!-- Venue Input -->
              <div class="col-md-6">
                <label for="venue" class="form-label">Venue</label>
                <input v-model="data.venue" type="text" id="venue" class="form-control" placeholder="Enter Venue..."
                  required />
                <div v-if="errors.venue">
                  <small class="text-danger">{{ errors.venue }}</small>
                </div>
              </div>

              <!-- Date Input -->
              <div class="col-md-3">
                <label for="venue-date" class="form-label">Date</label>
                <input v-model="data.unformattedDate" type="date" id="venue-date" class="form-control"
                  placeholder="mm/dd/yyyy" required />
                <div v-if="errors.unformattedDate">
                  <small class="text-danger">{{
                    errors.unformattedDate
                  }}</small>
                </div>
              </div>

              <!-- Time Input -->
              <div class="col-md-3">
                <label for="venue-time" class="form-label">Time</label>
                <input v-model="data.time" type="time" id="venue-time" class="form-control" placeholder="--:--"
                  required />
                <div v-if="errors.time">
                  <small class="text-danger">{{ errors.time }}</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Success Message -->
          <div class="mb-3">
            <label for="success-message" class="form-label">Success Message</label>
            <input v-model="data.success_message" type="text" id="success-message" class="form-control"
              placeholder="Enter success messages..." required />
            <div v-if="errors.success_message">
              <small class="text-danger">{{ errors.success_message }}</small>
            </div>
          </div>

          <!-- Decline Message -->
          <div class="mb-3" v-if="data.type === 2">
            <label for="decline-message" class="form-label">Decline Message</label>
            <input v-model="data.decline_message" type="text" id="decline-message" class="form-control"
              placeholder="Enter decline messages..." required />
            <div v-if="errors.decline_message">
              <small class="text-danger">{{ errors.decline_message }}</small>
            </div>
          </div>

          <!-- Upload Image -->
          <div class="mb-3">
            <label for="upload-image" class="form-label">Upload Image <span class="text-danger small">* Recommended
                image
                upload size 600px x 600px</span></label>
            <input type="file" ref="fileInput" id="upload-image" class="form-control" @change="handleFileUpload"
              accept="image/*" />
            <div v-if="errors.image_upload">
              <small class="text-danger">{{ errors.image_upload }}</small>
            </div>
          </div>

          <div class="mb-3" v-if="data.type === 2">
            <label for="quota" class="form-label">Set Quota</label>
            <div class="d-flex align-items-center">
              <input v-model="data.quota" type="number" id="quota" class="form-control me-2" style="width: 150px;"
                placeholder="Set Quota..." required />
            </div>
            <div v-if="errors.quota">
              <small class="text-danger">{{ errors.quota }}</small>
            </div>
          </div>

          <ConditionSelect v-for="(condition, index) in data.condition" :conditionOptions="conditionOptions"
            :key="index" :index="index" :errors="errors" @condition-change="onConditionChange"
            @disabled="handleDisabled" @value-change="onValueChange" @clear-error="clearError"
            :isOptionSelectable="isOptionSelectable" :label="index === 0
              ? 'Condition 1 (required)'
              : index === 1
                ? 'Condition 2 (optional)'
                : ''
              " />

          <div class="row g-2">
            <!-- Start Date -->
            <div class="mb-3 col-md-4">
              <label for="start_at" class="form-label">Start Date</label>
              <input type="date" v-model="data.start_at" id="start_at" class="form-control" placeholder="dd/mm/yyyy"
                required />
              <div v-if="errors.start_at">
                <small class="text-danger">{{ errors.start_at }}</small>
              </div>
              <div v-if="errors.start_end_date">
                <small class="text-danger">{{ errors.start_end_date }}</small>
              </div>
            </div>

            <!-- End Date -->
            <div class="mb-3 col-md-4">
              <label for="end-date" class="form-label">End Date</label>
              <input type="date" v-model="data.end_at" id="end-date" class="form-control" placeholder="dd/mm/yyyy"
                required />
              <div v-if="errors.end_at">
                <small class="text-danger">{{ errors.end_at }}</small>
              </div>
              <div v-if="errors.start_end_date">
                <small class="text-danger">{{ errors.start_end_date }}</small>
              </div>
            </div>

            <!-- Notification time  -->
            <div class="mb-3 col-md-4">
              <label for="notif-time" class="form-label">Notification Time</label>
              <input type="time" id="notif-time" v-model="data.notification_time" class="form-control"
                placeholder="--/--" required />
              <div v-if="errors.notification_time">
                <small class="text-danger">{{
                  errors.notification_time
                }}</small>
              </div>
            </div>
          </div>
          <!-- Submit Button -->
          <button type="submit" class="btn btn-primary">Submit</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { storeMyActivity } from "../../../services/MyActivityService";
import { getRequest } from "@/services/RequestService";
import ConditionSelect from "../../../components/ConditionSelect.vue";

export default {
  components: { vSelect, ConditionSelect },
  data() {
    return {
      conditionOptions: [
        { label: "Gender", value: "Gender", disabled: false },
        { label: "Age", value: "Age", disabled: false },
        { label: "Tier", value: "Tier", disabled: false }
      ],
      data: {
        type: 2,
        product_id: null,
        product: null,
        title: null,
        short_description: null,
        long_description: null,
        venue: null,
        date: null,
        unformattedDate: null,
        time: null,
        success_message: null,
        decline_message: null,
        quota: null,
        start_at: null,
        end_at: null,
        notification_time: null,
        image_upload: null,
        condition: [
          {
            field: null,
            value: null
          },
          {
            field: null,
            value: null
          }
        ]
      },

      errors: {},
      date: null,
      time: null,
      productOptions: [],
      tba_products: [],
      tbk_products: [],
      testForm: []
    };
  },

  methods: {
    async fetchProduct() {
      let type_id;

      switch (this.data.type) {
        case 3:
          type_id = 1;
          break;
        case 4:
          type_id = 2;
          break;
        default:
          type_id = 1;
          break;
      }
      try {
        const response = await getRequest(`products/get-list`);

        if (response.data.success) {
          this.tba_products = response.data.data.tba;
          this.tbk_products = response.data.data.tbk.filter(
            product => ![7, 8].includes(product.id)
          );
        }
      } catch (e) {
        console.error(e);
      }
    },

    handleDisabled(disabled) {
      const firstConditionField = this.data.condition[0].field;
      const secondConditionField = this.data.condition[1].field;

      this.conditionOptions.forEach(option => {
        if (option.value === firstConditionField) {
          option.disabled = true;
        } else if (option.value === secondConditionField) {
          option.disabled = true;
        } else {
          option.disabled = false;
        }
      });
    },

    clearError({ index, errorType }) {
      if (this.errors[errorType]) {
        delete this.errors[errorType];
      }
    },
    onConditionChange(value) {
      const { index, field } = value;
      this.data.condition[index].field = field;
    },

    isOptionSelectable(option) {
      if (this.data.condition[0].field === option.value) {
        option.disabled = true;
      }
      return !option.disabled;
    },

    onValueChange(e) {
      const { index, value } = e;

      if (
        this.data &&
        this.data.condition &&
        Array.isArray(this.data.condition)
      ) {
        this.data.condition[index].value = JSON.stringify(value);
      }
    },

    formatDateTime() {
      if (this.data.unformattedDate && this.data.time) {
        return `${this.data.unformattedDate} ${this.data.time}:00`;
      }
      return null;
    },

    formatTime() {
      if (this.data.notification_time) {
        const today = new Date();
        const [hours, minutes] = this.data.notification_time.split(":");

        today.setHours(parseInt(hours), parseInt(minutes), 0, 0);

        const pad = num => String(num).padStart(2, "0");

        return `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(
          today.getDate()
        )} ${pad(today.getHours())}:${pad(today.getMinutes())}:${pad(
          today.getSeconds()
        )}`;
      }
      return null;
    },

    onChangeProduct(event) {
      //
    },

    validateForm() {
      this.errors = {};

      const fields = [
        { name: "type", value: this.data.type, message: "Type is required." },
        {
          name: "title",
          value: this.data.title,
          message: "Title is required."
        },
        {
          name: "short_description",
          value: this.data.short_description,
          message: "Short description is required."
        },
        {
          name: "long_description",
          value: this.data.long_description,
          message: "Long description is required."
        },

        {
          name: "success_message",
          value: this.data.success_message,
          message: "Success message is required."
        },
        // { name: 'reminder', value: this.data.reminder, message: 'Reminder is required.' },

        {
          name: "start_at",
          value: this.data.start_at,
          message: "Start time is required."
        },
        {
          name: "end_at",
          value: this.data.end_at,
          message: "End time is required."
        },
        {
          name: "notification_time",
          value: this.data.notification_time,
          message: "Notification time is required."
        },
        // { name: 'active', value: this.data.active, message: 'Active status is required.' },
        // { name: 'cancelled_at', value: this.data.cancelled_at, message: 'Cancelled time is required.' },
        {
          name: "image_upload",
          value: this.data.image_upload,
          message: "Image upload is required."
        },
        {
          name: "field1",
          value: this.data.condition[0].field,
          message: "Condition 1 field is required."
        },
        {
          name: "value1",
          value: this.data.condition[0].value,
          message: "Condition 1 value is required."
        },
        {
          name: "product",
          value: this.data.product_id,
          message: "Product is required."
        }
      ];

      fields.forEach(field => {
        if (field.name === "product") {
          console.log("validating product", this.data.type)
          if (this.data.type !== 3 && this.data.type !== 4) {
            return;
          } else if (!field.value) {
            this.errors[field.name] = field.message;
          }
        } else if (!field.value) {
          this.errors[field.name] = field.message;
        }
      });

      // Validate conditions dynamically
      if (Array.isArray(this.data.condition)) {
        this.data.condition.forEach((condition, index) => {
          if (index === 0 && !condition.field) {
            this.errors[`field${index + 1}`] = `Condition ${index +
              1} field is required.`;
          }
          if (index === 0 && !condition.value) {
            this.errors[`value${index + 1}`] = `Condition ${index +
              1} value is required.`;
          }
        });

        if (
          this.data.condition[0] &&
          this.data.condition[1] &&
          this.data.condition[0].field &&
          this.data.condition[1].field &&
          this.data.condition[0].field === this.data.condition[1].field
        ) {
          this.errors["field1"] =
            "Condition 1 and Condition 2 cannot have the same field.";
          this.errors["field2"] =
            "Condition 1 and Condition 2 cannot have the same field.";
        }
      } else {
        this.errors["condition"] = "Conditions are required.";
      }

      if (this.data.type === 2) {
        // { name: 'decline_message', value: this.data.decline_message, message: 'Decline message is required.' },
        // { name: 'venue', value: this.data.venue, message: 'Venue is required.' },
        // { name: 'date', value: this.data.unformattedDate, message: 'Date is required.' },
        // { name: 'time', value: this.data.time, message: 'Time is required.' },
        if (
          !this.data.decline_message ||
          this.data.decline_message.trim() === ""
        ) {
          this.errors["decline_message"] = "Decline message is required.";
        }

        // Check if venue is empty
        if (!this.data.venue || this.data.venue.trim() === "") {
          this.errors["venue"] = "Venue is required.";
        }

        // Check if unformattedDate (or whatever your field is) is empty
        if (
          !this.data.unformattedDate ||
          this.data.unformattedDate.trim() === ""
        ) {
          this.errors["date"] = "Date is required.";
        }

        // Check if time is empty
        if (!this.data.time || this.data.time.trim() === "") {
          this.errors["time"] = "Time is required.";
        }
      }

      if (this.data.start_at && this.data.end_at) {
        const startDate = new Date(this.data.start_at);
        const endDate = new Date(this.data.end_at);

        if (endDate <= startDate) {
          this.errors["start_end_date"] =
            "End date must be greater than the start date.";
        }
      }

      if (this.data.type === 2 && !this.data.quota) {
        this.errors["quota"] = "Quota is required.";
      }

      if (Object.keys(this.errors).length > 0) {
        return false;
      }

      return true; // No errors
    },

    getNestedValue(obj, path) {
      return path.split(".").reduce((acc, key) => {
        const arrayMatch = key.match(/^(\w+)\[(\d+)\]$/);
        if (arrayMatch) {
          const [, arrayKey, index] = arrayMatch;
          return acc && acc[arrayKey] ? acc[arrayKey][index] : undefined;
        }
        return acc ? acc[key] : undefined;
      }, obj);
    },

    handleType(e) {
      this.fetchProduct();
      // this.data.product = e.target.value;
    },

    handleFileUpload(event) {
      const file = event.target.files[0];

      if (!file) {
        this.data.image_upload = null;
        return;
      }

      // Validate file type
      const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
      if (!allowedTypes.includes(file.type)) {
        swal({
          title: "Error",
          icon: "error",
          text: "Please upload a valid image file (JPEG, PNG, or GIF)"
        });
        this.data.image_upload = null;
        this.previewUrl = null;
        return;
      }

      // Validate file size (5MB)
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        swal({
          title: "Error",
          icon: "error",
          text: "Image size must be less than 5MB"
        });
        this.data.image_upload = null;
        this.previewUrl = null;
        return;
      }

      this.data.image_upload = file;
    },

    async submitForm() {
      if (this.validateForm()) {
        try {
          const formData = new FormData();

          // Add all properties from this.data to FormData
          for (const key in this.data) {
            if (this.data[key] === null || this.data[key] === undefined) {
              // Skip appending the key if it's null or undefined
              continue;
            }

            if (key === "image_upload" && this.data.image_upload) {
              // Simply append the file directly - it's already a File object
              if (this.data.image_upload instanceof File) {
                formData.append("image_upload", this.data.image_upload);
              }
            } else if (
              key === "condition" &&
              Array.isArray(this.data.condition)
            ) {
              // Loop through 'condition' and append individual items with [index] syntax
              this.data.condition.forEach((condition, index) => {
                formData.append(`condition[${index}][field]`, condition.field);
                formData.append(
                  `condition[${index}][value]`,
                  String(condition.value)
                ); // Ensure value is a string
              });
            } else if (
              key === "product_id" &&
              [3, 4].includes(this.data.type)
            ) {
              formData.append(key, Number(this.data.product_id));
            } else if (key === "product" && [3, 4].includes(this.data.type)) {
              formData.append(key, this.data.product.label);
            } else {
              // Add other fields
              formData.append(key, this.data[key]);
            }
          }
          if (this.data.type === 2) {
            formData.append("date", this.formatDateTime());
          }

          formData.append("notification_time", this.formatTime());
          formData.append("quota", Number(this.data.quota));
          formData.append("type", Number(this.data.type));

          const formDataArray = {};
          for (const [key, value] of formData.entries()) {
            formDataArray[key] = value;
          }

          // Assign the array to `this.testForm`
          this.testForm = formDataArray;
          // Send the request
          const response = await storeMyActivity(formData);

          swal({
            title: response.data.success ? "Success" : "Failed",
            icon: response.data.success ? "success" : "error",
            text: response.data.message
          });

          if (response.data.success) {
            this.$router.push({ name: "my_activity" });
          }
        } catch (e) {
          console.error("Form submission error:", e);
          swal({
            title: "Error",
            icon: "error",
            text: "Something went wrong, please try again later."
          });
        }
      } else {
        swal({
          title: "Error",
          icon: "error",
          text: "Please fill in all required fields."
        });
      }
    }
  },

  mounted() {
    this.fetchProduct();
  }
};
</script>

<style>
.opacity-50 {
  opacity: 0.5;
}

.custom-radio .form-check-input:checked {
  background-color: #ff5733 !important;
  /* Change this to your desired color */
  border-color: #ff5733 !important;
  /* Change the border color as well */
}

.custom-radio .form-check-input {
  border-radius: 50%;
  /* To ensure the button stays round */
}

input[type="radio"] {
  accent-color: #ac8400;
}
</style>
